import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";

export const TrilingualModel = () => {
  const { translations } = useLanguage();
  const t = translations?.trilingualModel;

  const stages = [
    { 
      key: "infantil" as const,
      color: "bg-primary",
      textColor: "text-primary"
    },
    { 
      key: "cycle1" as const,
      color: "bg-accent",
      textColor: "text-primary"
    },
    { 
      key: "cycle2" as const,
      color: "bg-secondary",
      textColor: "text-secondary"
    },
  ];

  if (!t) return null;

  return (
    <section className="py-20 px-4 bg-background">
      <div className="container mx-auto max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="section-title">{t.title}</h2>
          <p className="section-subtitle">{t.subtitle}</p>
        </motion.div>
        
        <div className="space-y-8 mb-12">
          {stages.map((stage, index) => {
            const stageData = t.stages[stage.key];
            const percentage = parseInt(stageData.percentage);
            
            return (
              <motion.div
                key={stage.key}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                viewport={{ once: true }}
                className="space-y-3"
              >
                <div className="flex items-baseline justify-between mb-2">
                  <h3 className="text-lg font-semibold text-foreground">
                    {stageData.title}
                  </h3>
                  <span className={`text-2xl font-bold ${stage.textColor}`}>
                    {stageData.percentage}
                  </span>
                </div>
                
                <div className="relative h-4 bg-muted/30 rounded-full overflow-hidden">
                  <motion.div
                    initial={{ width: 0 }}
                    whileInView={{ width: `${percentage}%` }}
                    transition={{ duration: 1, delay: index * 0.15 + 0.3, ease: "easeOut" }}
                    viewport={{ once: true }}
                    className={`h-full ${stage.color} rounded-full`}
                  />
                </div>
                
                <p className="text-sm text-muted-foreground pl-1">
                  {stageData.description}
                </p>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <p className="text-sm text-muted-foreground italic bg-muted/20 py-4 px-6 rounded-lg inline-block">
            {t.footer}
          </p>
        </motion.div>
      </div>
    </section>
  );
};
